import PropTypes from 'prop-types'
import BzButton from './BzButton';

const BzPrimaryToggle = ({ leftButtonTitle, rightButtonTitle, activeButtonToggleIndex, setActiveButtonToggleIndex }) => {
  return (
    <div className='primary-toggle-wrap'>
      <BzButton className={`btn btn-sm ${activeButtonToggleIndex === 0 ? 'btn-solid' : ''}`} onClick={() => setActiveButtonToggleIndex(0)}>{leftButtonTitle}</BzButton>
      <BzButton className={`btn btn-sm ${activeButtonToggleIndex === 1 ? 'btn-solid' : ''}`} onClick={() => setActiveButtonToggleIndex(1)}>{rightButtonTitle}</BzButton>
    </div>
  )
}

BzPrimaryToggle.propTypes = {
  leftButtonTitle: PropTypes.string.isRequired,
  rightButtonTitle: PropTypes.string.isRequired,
  activeButtonToggleIndex: PropTypes.number.isRequired,
  setActiveButtonToggleIndex: PropTypes.func.isRequired,
}

BzPrimaryToggle.defaultProps = {
  leftButtonTitle: '',
  rightButtonTitle: '',
  activeButtonToggleIndex: 0
}

export default BzPrimaryToggle